<template>
  <div class="list-box bg-gray-100 rounded-lg overflow-x-auto">
    <ul
      class="grid gap-x-3 mt-2"
      style="grid-template-columns: 300px 150px 80px 1fr auto"
    >
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
      </el-input>
      <el-select
        v-model="state.params.d_cost_type_id"
        placeholder="--物料类型--"
      >
        <el-option
          v-for="item in state.lx_data"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button
            plain
            class="float-right mb-3"
            size="small"
            @click="onLoadLx()"
          >
            刷新
          </el-button>
        </template>
      </el-select>
      <el-button type="primary" icon="Search" @click="onLoad()">
        查询
      </el-button>
      <div class="flex items-center justify-center">
        <template v-if="state.select_count > 0">
          <li class="text-xs">已选</li>
          <strong class="text-blue-500">{{ state.select_count }}</strong>
          <el-button link type="danger" size="small" @click="onClearSelect"
            >清空</el-button
          >
        </template>
      </div>
      <div class="flex items-center justify-end">
        <text class="text-gray-500">所属分会：</text>
        <el-select
          v-model="state.meeting_places"
          placeholder="--所属分会--"
          value-key="id"
          multiple
          :collapse-tags="state.collapseConfig?.status"
          :max-collapse-tags="state.collapseConfig?.max"
          collapse-tags-tooltip
          class="!w-96 select-mui-collapse"
          @change="onPlaceChange"
          ref="placeDom"
        >
          <el-option
            v-for="item in state.fh_data"
            :key="item"
            :label="item.name"
            :value="item"
          />
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadFh()"
            >
              刷新
            </el-button>
          </template>
        </el-select>
        <el-button
          type="success"
          icon="Select"
          @click="onSubmit()"
          class="ml-3"
        >
          提交
        </el-button>
      </div>
    </ul>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        row-key="id"
        ref="tableDom"
        @sort-change="onSortChange"
        @selection-change="onSelectChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column
          label="类型"
          prop="d_cost_type_name"
          :width="120"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="名称" prop="name" />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="规格" label2="单位" />
          </template>
          <template #default="{ row }">
            <text>{{ row.specification || "-" }}</text>
            <text class="text-xs text-gray-400">
              {{ "/" + row.d_measure_unit_name }}
            </text>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="price" :width="120" align="center">
          <template #default="{ row }">
            <c_money :key="row.price" :value="row.price" class="m-auto" />
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          :width="120"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          type="selection"
          :width="120"
          align="center"
          reserve-selection
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  dic_getCostType,
  data_getSupplierCostItem,
  data_getMeetingPlace,
} from "@/http/data";
import { ElMessage, ElMessageBox } from "element-plus";
import { onSelectCollapse } from "@/utils/funcs";

import { pageSize } from "@/utils/base";

class InitFormData {
  params = {
    page: 1,
    limit: pageSize,
  };
}

export default {
  props: {
    meeting_id: Number,
    d_cost_type_pid: Number,
    supplier_id: Number,
  },
  components: {
  },
  setup(props, { emit }) {
    const placeDom = ref(null);
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.d_cost_type_pid = props.d_cost_type_pid;
      state.params.supplier_id = props.supplier_id;
      onLoadLx();
      onLoad();
      onLoadFh();
    });

    //根据采购单的类型获取物料类型
    const onLoadLx = () => {
      if (props.d_cost_type_pid) {
        dic_getCostType({ pid: props.d_cost_type_pid }).then((res) => {
          if (res.status == 200) state.lx_data = res.data?.data || [];
        });
      }
    };

    const onLoad = () => {
      delete state.list_data;

      data_getSupplierCostItem(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //获取分会
    const onLoadFh = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.fh_data = res.data?.data?.list || [];
      });
    };

    const onPlaceChange = (e) => {
      onSelectCollapse(placeDom, state.collapseConfig, e).then((config) => {
        state.collapseConfig = config;
      });
    };

    const onRowClick = (item) => {
      tableDom.value.toggleRowSelection(item);
    };

    //选择项改变事件
    const onSelectChange = (e) => {
      state.select_count = e.length;
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
      state.select_count = 0;
    };

    const onSubmit = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows?.length > 0) {
        if (state.meeting_places?.length > 0) {
          emit("confirm", {
            rows: rows,
            meeting_places: state.meeting_places,
          });
        } else {
          ElMessageBox.confirm(`您尚未选择分会，确定保存吗？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            customClass: "c-delete-dialog",
            cancelButtonClass: "is-plain",
          }).then(() => {
            emit("confirm", {
              rows: rows,
              meeting_places: state.meeting_places,
            });
          });
        }
      } else {
        ElMessage.warning("请勾选要添加的物料！");
      }
    };

    return {
      state,
      props,
      onLoad,
      onLoadFh,
      tableDom,
      onRowClick,
      onSelectChange,
      onClearSelect,
      onSubmit,
      onLoadLx,
      onPlaceChange,placeDom
    };
  },
};
</script>

<style lang="scss" scoped></style>
